module.exports = __webpack_public_path__ + "media/bootstrap-icons/person-badge-a94973cd.svg";